import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Layout, Overlay, SplitPanelContainer, SplitPanelWrapper, TabBarAndWindowLayout } from './components/style';
import { RcsTemplateEditorBottomToolbar } from './components/RcsTemplateEditorBottomToolbar';
import { RcsTemplateEditorNameBar } from './components/RcsTemplateEditorNameBar';
import { RcsTemplateEditorLeftPane } from './components/RcsTemplateEditorLeftPane';
import { RcsTemplateEditorRightPane } from './components/RcsTemplateEditorRightPane';
import { useRcsTemplateEditorDispatch, useRcsTemplateEditorState } from './context/useRcsTemplateEditorContext';
import { useRcsPreviewVersion } from './hooks/useRcsPreviewVersion';
import { RCS_EDITOR_DEFAULT_PERCENTAGE, RCS_EDITOR_SPLIT_CONTAINER_CSS_ID } from './constants';

const MIN_RIGHT_PERCENTAGE = 0;

export const RcsTemplateEditor: React.FC = () => {
  const { rightWindowPercentage } = useRcsTemplateEditorState();
  const dispatch = useRcsTemplateEditorDispatch();

  useRcsPreviewVersion();
  const leftWindowPercentage = 100 - rightWindowPercentage;
  const history = useHistory();
  const { search } = useLocation();

  useEffect(() => {
    if (new URLSearchParams(search).get('newtab') === '1') {
      history.replace(history.location.pathname);
    }
  }, [history, search]);

  const onDragEnd = (sizes: number[]) => {
    const rightPercent = sizes[1];
    let percentage = rightPercent;
    if (Number.isNaN(percentage) || percentage >= 100) {
      percentage = RCS_EDITOR_DEFAULT_PERCENTAGE;
    } else if (percentage < MIN_RIGHT_PERCENTAGE) {
      percentage = MIN_RIGHT_PERCENTAGE;
    }
    dispatch({
      type: 'SET_RIGHT_WINDOW_PERCENTAGE',
      payload: { percentage },
    });
  };

  return (
    <Overlay>
      <Layout data-testid="RcsTemplateEditorLayout">
        <TabBarAndWindowLayout data-testid="RcsTemplateEditorMainSection">
          <RcsTemplateEditorNameBar />
          <SplitPanelWrapper>
            <SplitPanelContainer
              id={RCS_EDITOR_SPLIT_CONTAINER_CSS_ID}
              sizes={[leftWindowPercentage, rightWindowPercentage]}
              gutterSize={5}
              direction="horizontal"
              onDragEnd={onDragEnd}
            >
              <div>
                <RcsTemplateEditorLeftPane />
              </div>
              <div>
                <RcsTemplateEditorRightPane />
              </div>
            </SplitPanelContainer>
          </SplitPanelWrapper>
        </TabBarAndWindowLayout>
        <RcsTemplateEditorBottomToolbar />
      </Layout>
    </Overlay>
  );
};
